var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('input',{ref:"autocompleteInput",staticClass:"border-none",class:_vm.inputClass,attrs:{"id":_vm.id,"type":"text","placeholder":_vm.placeholder,"required":""},on:{"input":_setup.isEmpty}})
}
var staticRenderFns = []

export { render, staticRenderFns }